// removed by extract-text-webpack-plugin
module.exports = {"header":"app-y9bPXy3o","logo":"app-21dramd0","menu":"app-1Yaq8TcZ","trigger":"app-1PmYWR6r","right":"app-16lWvNDE","action":"app-3jilP5qL","search":"app-2hJAYSWU","account":"app-2xjd1CLX","avatar":"app-2TMxuPtv","name":"app-kuYMmdj_"};


//////////////////
// WEBPACK FOOTER
// ./src/wbap-mian-apps/wbap-admin-main/components/GlobalHeader/index.less
// module id = 859
// module chunks = 0